(function($) {
  $(document).ready(function() {

    var $postsContainer = $('.blog-posts-container');
    var $paginationContainer = $('.pagination');
    var $categoryLinks = $('.category-selector--categories a');

    function loadBlogPage(url) {
      if (!url) return;

      $postsContainer.addClass('loading');

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'html',
        success: function(response) {
          var $html = $(response);
          var $newPosts = $html.find('.blog-posts-container');
          var $newPagination = $html.find('.pagination');

          $postsContainer.html($newPosts.html());
          $paginationContainer.html($newPagination.html());

          $('html, body').animate({ scrollTop: $postsContainer.offset().top - 250 }, 300);

          $postsContainer.removeClass('loading');
        },
        error: function() {
          console.error('Failed to load blog page: ' + url);
          $postsContainer.removeClass('loading');
        }
      });
    }

    $categoryLinks.on('click', function(e) {
      e.preventDefault();

      $categoryLinks.parent().removeClass('selected');
      $(this).parent().addClass('selected');

      var url = $(this).attr('href');
      loadBlogPage(url);

      // Push state with custom flag
      history.pushState({ ajax: true }, '', url);
    });

    $paginationContainer.on('click', 'a', function(e) {
      e.preventDefault();
      var url = $(this).attr('href');
      if (url && url !== '#') {
        loadBlogPage(url);
        history.pushState({ ajax: true }, '', url);
      }
    });

    window.onpopstate = function(event) {
      // Only load via AJAX if our custom flag exists
      if (event.state && event.state.ajax) {
        loadBlogPage(location.href);
      }
    };

  });
})(jQuery);
